<template>
    <v-container class="main-container">
      <message-component id="message" v-model="isMessage" :success="success">{{ message }}</message-component>      
      <v-container style="margin-top: 15px;">
        <v-row>
            <v-col cols="12" xl="6" class="text-h4">企業用印影一覧</v-col>
            <template v-if="user.role == 1"> <!-- 管理者 -->
                <v-col cols="12" xl="6" class="text-right">
                    <v-btn color="orange" class="white--text" @click="clickAdd">追加</v-btn>
                </v-col>
            </template>
        </v-row>
      </v-container>
  
  <!-- 削除 -->
  <delete-dialog-component v-if="deleteDialog" :deleteDialog.sync="deleteDialog" :item="{id: currentItem.id, table: '/documents/delete-company-imprints/'}" @success="getcompanys" @error="error">
      <template v-slot:title>削除してよろしいですか？</template>
      <template v-slot:ok-btn>削除</template>
      <template v-slot:cancel-btn>キャンセル</template>
  </delete-dialog-component>
  
  <!-- グループ追加 -->
  <companyimprints-add-dialog-component v-if="addDialog" :addDialog.sync="addDialog" @success="getcompanys">
      <template v-slot:cancel-btn>キャンセル</template>
      <template v-slot:ok-btn>登録</template>
  </companyimprints-add-dialog-component>

    <!-- 一覧表示 -->
    <v-row justify="center">
      <v-col
        cols="12"
      >  
        <v-simple-table class="pa-6">
          <template v-slot:default>
            <thead>
              <tr>
                <th>
                  名称
                </th>
                <th>
                  印影
                </th>
                <th>
                　操作ボタン
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(company, idx) in new_companys"
                :key="idx"
              >
                <td>{{ company.imprint_name }}</td>
                <td>
                    <v-img
                        :src="company.image_data"
                        max-height="40"
                        max-width="40"
                        width="40"
                        height="40"
                        :contain="true"
                    >
                    </v-img>
                
                </td>
                <td>
                  <template v-if="user.role == 1"> <!-- 管理者 -->
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue-grey"
                      class="white--text"
                      @click="clickDelete(company)"
                    >
                    削除
                    </v-btn>
                  </template>
              　</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import axios from 'axios';
  export default {
    props: {
        companys: {
          type: Array,
          required: true
        },
        user: [],
    },  
    data() {
        return {
            addDialog: false,
            new_companys: this.companys,
            // 削除 開閉フラグ
            deleteDialog: false,
            // メッセージ
            message: null,
            success: false,            
        };
    },
    methods: {
        getcompanys(message) {
            axios
                .get("/documents/get-companys")
                .then(response => {
                    this.new_companys = response.data.companys;
                    this.success = true;
                    this.message = message;                    
                })
                .catch(err => {
                    this.success = false;
                    this.message = err;
                });
        },
        // 削除ボタン押下
        clickDelete(item) {
            this.deleteDialog = true;
            this.currentItem = item;
        },        
        // エラー
        error(message) {
            this.success = false;
            this.message = message;
        },        
        // 追加ボタン押下
        clickAdd() {
            this.addDialog = true;
        },
    },
    computed: {
        // メッセージ
        isMessage: {
            get() {
                return this.message != null;
            },
            set(value) {
                if (!value) {
                    this.message = null;
                }
            }
        },
    },    
};
</script>

<style scoped>
  ::v-deep td {
    padding: 5px 0!important;
  }
</style>
